import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "/social"
  },
  {
    path: "/school",
    name: "school",
    component: () => import("@/views/jobs/jobs-school")
  },
  {
    path: "/social",
    name: "social",
    component: () => import("@/views/jobs/jobs-social")
  }
];

const router = new VueRouter({
  routes
});

export default router;
